import React, { useRef, useEffect, useState } from "react";
import { UserLogo } from "lib/models";
import { useAppContext } from "lib/state/TextProvider";
import { updateUserProfile } from "lib/api";
import * as FaIcons from "react-icons/fa";

const LogoSelector = () => {
  const { state, setUserProfileNeedsReload } = useAppContext();
  const [selectedLogo, setSelectedLogo] = useState<UserLogo>(
    state.userProfile?.userLogo ?? "FaMoon",
  );
  const selectedLogoRef = useRef<HTMLButtonElement | null>(null);
  const ALL_ICONS: { [key: UserLogo]: any } = Object.entries(FaIcons);
  const SelectedLogo = (
    FaIcons as Record<
      UserLogo,
      React.FC<{ onClick?: () => void; className?: string }>
    >
  )[selectedLogo];

  const handleSelect = async (userLogo: UserLogo): Promise<void> => {
    await updateUserProfile({ userLogo });
    setUserProfileNeedsReload(true);
    setSelectedLogo(userLogo);
  };

  useEffect(() => {
    if (selectedLogoRef.current) {
      selectedLogoRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedLogo]);

  return (
    <div className="bg-palette-5 text-palette-2 rounded-lg border-2 border-palette-3 p-4">
      <h2 className="text-lg font-bold mb-2">Logo</h2>
      <div className="mb-4 w-fit flex space-x-2 items-center">
        <span>Selected: </span>
        <SelectedLogo className="w-8 h-fit text-palette-2" />
      </div>
      <div className="bg-palette-4 text-palette-2 rounded-lg border-2 border-palette-3">
        <div className="grid grid-cols-3 gap-4 max-h-80 overflow-auto p-4">
          {ALL_ICONS.map(([iconName, IconComponent]: [UserLogo, any]) => (
            <button
              key={`userLogoSelector:${iconName}`}
              type="button"
              ref={iconName === selectedLogo ? selectedLogoRef : undefined}
              onClick={() => handleSelect(iconName)}
              className={`p-2 rounded-lg border-2 border-palette-3 transition-all duration-200 focus:outline-none ${
                iconName === selectedLogo
                  ? "bg-palette-3"
                  : "bg-palette-4 hover:bg-palette-2"
              }`}
            >
              <IconComponent />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoSelector;
